// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NcFr7","question":"styles_question__O8Nw2","inputVisibleButton":"styles_inputVisibleButton__b2ioQ","note":"styles_note__2n4IX"};